import { render, staticRenderFns } from "./instantMessage.vue?vue&type=template&id=1358f16d"
import script from "./instantMessage.vue?vue&type=script&lang=js"
export * from "./instantMessage.vue?vue&type=script&lang=js"
import style0 from "./instantMessage.vue?vue&type=style&index=0&id=1358f16d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports